import { render, staticRenderFns } from "./AcronymsList.vue?vue&type=template&id=181b9d92"
import script from "./AcronymsList.vue?vue&type=script&lang=js"
export * from "./AcronymsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports